import React, { useMemo } from 'react';

import groupBy from 'lodash/groupBy';
import { Link } from 'react-router-dom';

import TENANTS from '../../../consts/tenant';

import ScheduleHistory from './ScheduleHistory';

function formateDate(date_in) {
  const date = new Date(date_in);
  return date.toDateString();
}

type Props = {
  offer: {
    result: App.Offer;
  };
  schedules: App.Offer['brand_schedules'];
};

function schedulesFor(schedulesGrouped, brand) {
  const schedules_index: {
    list_visibility: Array<App.Schedule>;
    availability?: App.Schedule;
    online_purchase?: App.Schedule;
  } = {
    list_visibility: [],
  };
  const schedules = {
    list: [],
    country_list: [],
  };

  if (!schedulesGrouped[brand]) {
    return schedules;
  }

  for (const schedule of schedulesGrouped[brand]) {
    if (schedule.type === 'availability' || schedule.type === 'online_purchase') {
      schedules_index[schedule.type] = schedule;
    } else if (schedule.type === 'list_visibility') {
      schedules_index[schedule.type].push(schedule);
    }
  }

  // This elaborate charade is needed because we need to account for the fact that any given schedule may be missing
  if (schedules_index.availability) {
    schedules.list.push({
      title: 'Start Private Sales:',
      date: formateDate(schedules_index.availability.start),
    });
  }

  if (schedules_index.online_purchase) {
    schedules.list.push({
      title: 'Start Online Sales:',
      date: formateDate(schedules_index.online_purchase.start),
    });
    schedules.list.push({
      title: 'End Online Sales:',
      date: formateDate(schedules_index.online_purchase.end),
    });
  }

  if (schedules_index.availability) {
    schedules.list.push({
      title: 'End Private Sales:',
      date: formateDate(schedules_index.availability.end),
    });
  }

  for (const schedule of schedules_index.list_visibility) {
    schedules.country_list.push({
      title: schedule.region,
      dateFrom: formateDate(schedule.start),
      dateTo: formateDate(schedule.end),
    });
  }
  return schedules;
}

function TimelinePane({ offer, schedules }: Props) {
  const schedulesGrouped = useMemo(() => groupBy(schedules, (s) => s.brand), [schedules]);
  const offerId = offer.result.id_salesforce_external;

  return (
    <span>
      {Object.keys(TENANTS).map((k) => {
        const brand = TENANTS[k].brand;
        const brandSchedules = schedulesFor(schedulesGrouped, brand);
        return (
          <div className="panel-section" key={k}>
            <h2>
              <span>
                {TENANTS[k].title}
                <ScheduleHistory offerId={offerId} brand={brand} />
              </span>
              <Link to={'/edit-offers/' + offerId + `/schedules/${brand}`}>
                <button type="button" className="btn btn-primary">
                  {brandSchedules.list.length === 0 ? 'Add Schedule' : 'Edit Schedule'}
                </button>
              </Link>
            </h2>
            <div className="timeline-wrapper">
              {brandSchedules.list.map((schedule_string) => (
                <dl className="timeline-item" key={schedule_string.title}>
                  <dt className="h6 text-uppercase text-muted">{schedule_string.title}</dt>
                  <dd>{schedule_string.date}</dd>
                </dl>
              ))}
            </div>
            {brandSchedules.country_list.length !== 0 && (
              <p className="h6 text-muted text-uppercase">Front-page visibility by country:</p>
            )}
            <div className="timeline-wrapper">
              {brandSchedules.country_list.length !== 0 &&
                brandSchedules.country_list.map((schedule_string) => (
                  <dl key={schedule_string.title}>
                    <dt className="h5 text-capitalize">{schedule_string.title}</dt>
                    <dd>
                      {schedule_string.dateFrom} - {schedule_string.dateTo}
                    </dd>
                  </dl>
                ))}
            </div>
          </div>
        );
      })}
    </span>
  );
}

export default TimelinePane;
